import HeaderCompact from './HeaderCompact'
export type * from './types'
export default HeaderCompact
